<template>
    <form @submit.prevent="onUpdate(data)" class="card">
        <div class="card-body">
            <h5 class="card-title fw-semibold mb-4">Configuración de correo electrónico</h5>
            <div class="form-group mb-3">
                <label>Protocolo : <span class="text-danger">*</span></label>
                <input type="text" class="form-control" name="MAIL_MAILER" v-model="data.MAIL_MAILER"
                    placeholder="MAIL_MAILER">
            </div>
            <div class="form-group mb-3">
                <label>Nombre de host : <span class="text-danger">*</span></label>
                <input type="text" class="form-control" name="MAIL_HOST" v-model="data.MAIL_HOST" placeholder="MAIL_HOST">
            </div>
            <div class="form-group mb-3">
                <label>Puerto : <span class="text-danger">*</span></label>
                <input type="text" class="form-control" name="MAIL_PORT" v-model="data.MAIL_PORT"
                    placeholder="MAIL_PORT">
            </div>
            <div class="form-group mb-3">
                <label>Usuario : <span class="text-danger">*</span></label>
                <input type="text" class="form-control" name="MAIL_USERNAME" v-model="data.MAIL_USERNAME"
                    placeholder="MAIL_USERNAME">
            </div>
            <div class="form-group mb-3">
                <label>Contraseña : <span class="text-danger">*</span></label>
                <input type="text" class="form-control" name="MAIL_PASSWORD" v-model="data.MAIL_PASSWORD"
                    placeholder="MAIL_PASSWORD">
            </div>
            <div class="form-group mb-3">
                <label>Cifrado de correo : <span class="text-danger">*</span></label>
                <input type="text" class="form-control" name="MAIL_ENCRYPTION" v-model="data.MAIL_ENCRYPTION"
                    placeholder="MAIL_ENCRYPTION">
            </div>
            <div class="form-group mb-3">
                <label>Correo electrónico : <span class="text-danger">*</span></label>
                <input type="text" class="form-control" name="MAIL_FROM_ADDRESS" v-model="data.MAIL_FROM_ADDRESS"
                    placeholder="MAIL_FROM_ADDRESS">
            </div>
            <div class="form-group mb-3">
                <label>Nombre de correo electrónico : <span class="text-danger">*</span></label>
                <input type="text" class="form-control" name="MAIL_FROM_NAME" v-model="data.MAIL_FROM_NAME"
                    placeholder="MAIL_FROM_NAME">
            </div>
        </div>
        <div class="card-footer">
            <button type="submit" class="btn btn-success rounded-pill px-4">
                <span v-if="count > 0" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                <span :class="{ 'visually-hidden': count > 0 }">
                    <i class="ti ti-device-floppy me-1 fs-4"></i> Guardar cambios
                </span>
            </button>
        </div>
    </form>
</template>
<script>
export default {
  data () {
    return {
      data: {},
      count: 0
    }
  },
  created () {
    this.onInit()
  },
  methods: {
    onInit: function () {
      this.$axios({
        url: '/mail/settings',
        method: 'GET'
      })
        .then((resp) => {
          this.data = resp.data
        })
    },
    onUpdate: function (data) {
      this.count++
      if (this.count !== 1) {
        return
      }
      this.$axios({
        url: '/mail/settings',
        method: 'POST',
        data: data
      })
        .then((resp) => {
          this.$swal({ toast: true, icon: 'success', title: resp.data.message, position: 'top-end', showConfirmButton: false, timer: 3000 })
        })
        .catch((err) => {
          let message = err.response ? err.response.data.message : err.message
          this.$swal({ toast: true, icon: 'error', title: message, position: 'top-end', showConfirmButton: false, timer: 3000 })
        })
        .finally((resp) => {
          this.count = 0
        })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/config/Mail.vue